import { DeleteIcon } from "@chakra-ui/icons";
import { Checkbox, HStack, IconButton, Input, Td, Tr } from "@chakra-ui/react";
import Select from "../../../shared/components/Select";

export interface DraftItem {
  id: string;
  section: string;
  order: number;
  code: string;
  label: string;
  isPersonalCare: boolean;
}

let draftCounter = 0;

export function newDraftItem(params: { section: string; order: number }): DraftItem {
  draftCounter += 1;
  return {
    id: `draft-${draftCounter}`,
    section: params.section,
    order: params.order,
    code: "",
    label: "",
    isPersonalCare: false,
  };
}

interface Props {
  draft: DraftItem;
  sections: string[];
  onChange: (patch: Partial<DraftItem>) => void;
  onRemove: () => void;
}

/**
 * An unsaved task. Sections are a free-text field with the existing sections offered as
 * shortcuts, so a new section can be introduced without a separate management step.
 */
export default function PlanOfCareDraftItemRow(props: Props) {
  return (
    <Tr bg="blue.50">
      <Td>
        <HStack spacing={1}>
          <Input
            placeholder="Section"
            size="sm"
            value={props.draft.section}
            onChange={(e) => props.onChange({ section: e.target.value })}
          />
          {props.sections.length > 0 && (
            <Select
              allowUnselect={false}
              label=""
              multiple={false}
              options={props.sections.map((value) => ({ label: value, value }))}
              value={null}
              onChange={(value) => value !== undefined && props.onChange({ section: value })}
            />
          )}
        </HStack>
      </Td>
      <Td>
        <Input
          min={1}
          size="sm"
          type="number"
          value={props.draft.order}
          width="70px"
          onChange={(e) => props.onChange({ order: Number(e.target.value) })}
        />
      </Td>
      <Td>
        <Input
          placeholder="Code"
          size="sm"
          value={props.draft.code}
          onChange={(e) => props.onChange({ code: e.target.value })}
        />
      </Td>
      <Td>
        <Input
          placeholder="Task name"
          size="sm"
          value={props.draft.label}
          onChange={(e) => props.onChange({ label: e.target.value })}
        />
      </Td>
      <Td>
        <Checkbox
          isChecked={props.draft.isPersonalCare}
          onChange={(e) => props.onChange({ isPersonalCare: e.target.checked })}
        />
      </Td>
      <Td>
        <IconButton
          aria-label="Remove task"
          icon={<DeleteIcon />}
          size="xs"
          variant="ghost"
          onClick={props.onRemove}
        />
      </Td>
    </Tr>
  );
}
